@let isCollapsed = $state().collapsible.is; @let isDestroyOnCollapse = $state().collapsible.doDestroy; @let
isRenderPanelBody = !isDestroyOnCollapse || ( isDestroyOnCollapse && !isCollapsed ); @let panelHeaderTitle =
$state().header.title;
<ng-content select="header">
  <header class="header">
    <h3 class="title">{{ panelHeaderTitle }}</h3>
  </header>
</ng-content>
@if( isRenderPanelBody ){
<ng-content select="body">
  <section class="body">
    <p class="is-empty">No panel <em>body content</em> has been supplied.</p>
  </section>
</ng-content>
}
